import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { NumberOnlyDirectiveModule } from '../directives/number-only/number-only.module'
import { InputPhoneComponent } from './input-phone.component'

@NgModule({
    declarations: [InputPhoneComponent],
    imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, NumberOnlyDirectiveModule, ReactiveFormsModule],
    exports: [InputPhoneComponent],
    providers: [],
})
export class InputPhoneModule {}
